// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Loader_wrapper__mtK6t","loader":"Loader_loader__dem4h","animate":"Loader_animate__IXCJE"};